import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  INVOICEPAYMENTTYPE_SHOW_ERROR,
  INVOICEPAYMENTTYPE_SHOW_LOADING,
  INVOICEPAYMENTTYPE_SHOW_RETRIEVED_SUCCESS,
  INVOICEPAYMENTTYPE_SHOW_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  retrieved: null
};

function error(error) {
  return {type: INVOICEPAYMENTTYPE_SHOW_ERROR, error};
}

function loading(loading) {
  return {type: INVOICEPAYMENTTYPE_SHOW_LOADING, loading};
}

function retrieved(retrieved) {
  return {type: INVOICEPAYMENTTYPE_SHOW_RETRIEVED_SUCCESS, retrieved};
}

function reset() {
  return {type: INVOICEPAYMENTTYPE_SHOW_RESET};
}

const getters = {
  error: state => state.error,
  loading: state => state.loading,
  item: state => state.retrieved
};

const actions = {
  retrieve({ commit }, id) {
    commit(loading(true));
    commit(error(null));
   return http.fetch('/invoice_payment_types/' + id)
      .then(response => response.json())
      .then(data => {
        commit(loading(false));
        commit(retrieved(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(error(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [INVOICEPAYMENTTYPE_SHOW_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [INVOICEPAYMENTTYPE_SHOW_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [INVOICEPAYMENTTYPE_SHOW_RETRIEVED_SUCCESS] (state, payload) {
      state.retrieved = payload.retrieved;
    },
    [INVOICEPAYMENTTYPE_SHOW_RESET] (state) {
      state.retrieved = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/invoicepaymenttype/show.js